<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">แก้ไขทีมงาน</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
          <div class="title_page ma-3">
            <v-btn
              type="button"
              class="btn_back_page"
              elevation="4"
              @click="$router.back()"
              large
              >ย้อนกลับ</v-btn
            >
          </div>
        </v-col>
      </v-row>

      <v-card elevation="4" style="border-radius: 15px">
        <v-card-text>
          <div class="mt-3 pa-4">
            <v-form ref="form" @submit.prevent="editEmployee">
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/avatar_white.png" />
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">ข้อมูลทั่วไป</div>
                    </div>
                  </div>
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="4" xl="3" cols="12">
                  <v-form-group>
                    <v-file-input
                      id="fileUpload_picture"
                      accept="image/*"
                      @change="onFileChange_picture"
                      prepend-icon=""
                      v-model="picture"
                      hide-input
                    />
                    <label class="label_form_text"
                      >รูปภาพนักงาน <span class="required--text">*</span></label
                    >
                    <v-img
                      v-if="input_set.emp_picture !== null"
                      :src="input_set.emp_picture"
                      style="max-width: 250px; max-height: 250px; height: 250px"
                      class="preview profile_img"
                    >
                      <v-btn
                        elevation="4"
                        class="mt-2 btn_edit_logo"
                        outlined
                        color="#FEA06C"
                        @click="getFile_picture"
                        title="อัพโหลดรูปพนักงาน"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </v-img>
                    <v-img
                      v-else
                      :src="img_holder_cert"
                      class="preview profile_img"
                      style="max-width: 250px; max-height: 250px; height: 250px"
                    >
                      <v-btn
                        elevation="4"
                        class="mt-2 btn_edit_logo"
                        outlined
                        color="#FEA06C"
                        title="อัพโหลดรูปพนักงาน"
                        @click="getFile_picture"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </v-img>
                  </v-form-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="6" xl="6" cols="12">
                  <v-form-group>
                    <label class="label_form_text"
                      >กรุณากรอกรหัสพนักงาน
                      <span class="required--text">*</span></label
                    >
                    <v-text-field
                      color="#D6BFAF"
                      class="input-radius"
                      prepend-inner-icon="mdi-card-account-details"
                      maxlength="30"
                      hide-details="auto"
                      :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']"
                      v-model="input_set.em_code"
                      placeholder="กรุณากรอกรหัสพนักงาน"
                      single-line
                      outlined
                      dense
                      required
                      @input="checkFirstChar"
                    ></v-text-field>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="6" xl="6" cols="12">
                  <v-form-group>
                    <label class="label_form_text"
                      >ชื่อ-สกุล <span class="required--text">*</span></label
                    >
                    <v-text-field
                      color="#D6BFAF"
                      class="input-radius"
                      prepend-inner-icon="mdi-account"
                      hide-details="auto"
                      :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']"
                      v-model="input_set.name"
                      maxlength="40"
                      placeholder="กรุณากรอกชื่อ-สกุล"
                      single-line
                      outlined
                      dense
                      @input="checkFirstCharName"
                      required
                    ></v-text-field>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="6" xl="6" cols="12">
                  <v-form-group>
                    <label class="label_form_text"
                      >รหัสผ่าน (หากไม่ต้องการเปลี่ยนให้เว้นว่าง)</label
                    >
                    <v-text-field
                      color="#D6BFAF"
                      class="input-radius"
                      prepend-inner-icon="mdi-lock"
                      v-model="password"
                      placeholder="กรอกรหัสผ่านใหม่"
                      type="password"
                      hide-details="auto"
                      single-line
                      outlined
                      dense
                    ></v-text-field>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="6" xl="6" cols="12">
                  <v-form-group>
                    <label class="label_form_text">ยืนยันรหัสผ่าน</label>
                    <v-text-field
                      color="#D6BFAF"
                      class="input-radius"
                      prepend-inner-icon="mdi-lock-check"
                      v-model="password_confirmation"
                      placeholder="กรอกรหัสผ่านใหม่อีกครั้ง"
                      type="password"
                      :rules="[
                        (v) =>
                          !password || v === password || 'รหัสผ่านไม่ตรงกัน',
                      ]"
                      hide-details="auto"
                      single-line
                      outlined
                      dense
                    ></v-text-field>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="5" xl="5" cols="12">
                  <label class="label_form_text"
                    >เบอร์โทร <span class="required--text">*</span></label
                  >
                  <v-otp-input
                    type="number"
                    hide-details="auto"
                    :rules="[
                      (v) => (!!v && v.length >= 10) || 'กรุณากรอกข้อมูล',
                    ]"
                    v-model="input_set.tel"
                    length="10"
                    @keypress="isNumber($event, input_set.tel)"
                    placeholder="x"
                    single-line
                    outlined
                    dense
                    required
                  ></v-otp-input>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/bank_white.png" />
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">ข้อมูลธนาคาร</div>
                    </div>
                  </div>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="6" xl="6" cols="12">
                  <v-form-group>
                    <label class="label_form_text">ธนาคาร </label>
                    <v-autocomplete
                      color="#D6BFAF"
                      class="input-radius"
                      :items="banking_list"
                      item-text="name"
                      item-value="id"
                      v-model="input_set.bank"
                      prepend-inner-icon="mdi-bank"
                      hide-details="auto"
                      placeholder="กรุณาเลือกธนาคาร"
                      single-line
                      outlined
                      dense
                      required
                    ></v-autocomplete>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="6" xl="6" cols="12">
                  <v-form-group>
                    <label class="label_form_text">เลขที่บัญชี </label>
                    <v-text-field
                      color="#D6BFAF"
                      class="input-radius"
                      prepend-inner-icon="mdi-bank"
                      hide-details="auto"
                      v-model="input_set.bank_number"
                      @keypress="isNumber($event, bank_number)"
                      counter
                      maxlength="15"
                      placeholder="กรุณากรอกเลขที่บัญชี"
                      single-line
                      outlined
                      dense
                      required
                    ></v-text-field>
                  </v-form-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/image-gallery.png" />
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">ข้อมูลรูปภาพหลักฐาน</div>
                    </div>
                  </div>
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12">
                  <v-form-group>
                    <v-file-input
                      id="fileUpload_id_card"
                      accept="image/*"
                      @change="onFileChange_id_card"
                      prepend-icon=""
                      v-model="id_card"
                      hide-input
                    />
                    <label class="label_form_text">
                      รูปภาพบัตรประชาชน (ขนาดไม่เกิน 500x700 พิกเซล)
                    </label>
                    <v-img
                      v-if="input_set.id_care !== null"
                      :src="input_set.id_care"
                      class="preview profile_img"
                      style="max-width: 250px; max-height: 250px; height: 250px"
                    >
                      <v-btn
                        elevation="4"
                        class="mt-2 btn_edit_logo"
                        outlined
                        color="#FEA06C"
                        @click="getFile_id_card"
                        title="อัพโหลดรูปภาพใบประกอบวิชาชีพ"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn></v-img
                    >
                    <v-img
                      v-else
                      :src="img_holder_cert"
                      class="preview profile_img"
                      style="max-width: 250px; max-height: 250px; height: 250px"
                    >
                      <v-btn
                        elevation="4"
                        class="mt-2 btn_edit_logo"
                        outlined
                        color="#FEA06C"
                        @click="getFile_id_card"
                        title="อัพโหลดรูปภาพใบประกอบวิชาชีพ"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn></v-img
                    >
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12">
                  <v-form-group>
                    <v-file-input
                      id="fileUpload_pharmacycouncil"
                      accept="image/*"
                      @change="onFileChange_pharmacycouncil"
                      prepend-icon=""
                      v-model="pharmacycouncil"
                      hide-input
                    />
                    <label class="label_form_text">
                      รูปภาพใบประกอบวิชาชีพ (ขนาดไม่เกิน 500x700 พิกเซล)
                    </label>
                    <v-img
                      v-if="input_set.pharmacycouncil !== null"
                      :src="input_set.pharmacycouncil"
                      style="max-width: 250px; max-height: 250px; height: 250px"
                      class="preview profile_img"
                    >
                      <v-btn
                        elevation="4"
                        class="mt-2 btn_edit_logo"
                        outlined
                        color="#FEA06C"
                        @click="getFile_pharmacycouncil"
                        title="อัพโหลดรูปภาพใบประกอบวิชาชีพ"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn></v-img
                    >
                    <v-img
                      v-else
                      :src="img_holder_cert"
                      class="preview profile_img"
                      style="max-width: 250px; max-height: 250px; height: 250px"
                    >
                      <v-btn
                        elevation="4"
                        class="mt-2 btn_edit_logo"
                        outlined
                        color="#FEA06C"
                        @click="getFile_pharmacycouncil"
                        title="อัพโหลดรูปภาพใบประกอบวิชาชีพ"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn></v-img
                    >
                  </v-form-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/padlock_white.png" />
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">
                        สิทธิการเข้าถึงข้อมูลภายในระบบ
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col xs="12" sm="12" md="6" lg="4" xl="4" cols="12">
                  <v-radio-group v-model="input_set.claim_status" mandatory>
                    <div class="grid_radio">
                      <div class="d-flex">
                        <div>
                          <v-radio color="#D6BFAF" :value="0"></v-radio>
                        </div>
                        <div>สิทธิ์การเข้าถึงทั้งหมด</div>
                      </div>
                      <div class="d-flex">
                        <div>
                          <v-radio color="#D6BFAF" :value="1"></v-radio>
                        </div>
                        <div>เข้าถึงบางสิทธิ์</div>
                      </div>
                    </div>
                  </v-radio-group>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-card
                    v-if="input_set.claim_status === 1"
                    elevation="4"
                    class="pa-4"
                    style="border-radius: 15px"
                  >
                    <v-row>
                      <v-col xs="12" sm="12" md="6" lg="4" xl="4" cols="12">
                        <v-checkbox
                          class="ma-0"
                          color="#D6BFAF"
                          v-model="input_set.claim_POS"
                          hide-details="auto"
                          label="สิทธิ์การเข้าถึงการขาย"
                        ></v-checkbox>
                      </v-col>
                      <v-col xs="12" sm="12" md="6" lg="4" xl="4" cols="12">
                        <v-checkbox
                          class="ma-0"
                          color="#D6BFAF"
                          v-model="input_set.claim_barcode"
                          hide-details="auto"
                          label="สิทธิ์การเข้าถึงการสร้างและพิมพ์บาร์โค้ด"
                        ></v-checkbox>
                      </v-col>
                      <v-col xs="12" sm="12" md="6" lg="4" xl="4" cols="12">
                        <v-checkbox
                          class="ma-0"
                          color="#D6BFAF"
                          v-model="input_set.claim_cancelbill"
                          hide-details="auto"
                          label="สิทธิ์การยกเลิกบิล"
                        ></v-checkbox>
                      </v-col>
                      <v-col xs="12" sm="12" md="6" lg="4" xl="4" cols="12">
                        <v-checkbox
                          class="ma-0"
                          color="#D6BFAF"
                          v-model="input_set.claim_report"
                          hide-details="auto"
                          label="สิทธิ์การเข้าหน้าดูรายงานร้าน"
                        ></v-checkbox>
                      </v-col>
                      <v-col xs="12" sm="12" md="6" lg="4" xl="4" cols="12">
                        <v-checkbox
                          class="ma-0"
                          color="#D6BFAF"
                          v-model="input_set.claim_store"
                          hide-details="auto"
                          label="สิทธิ์การเข้าตั้งค่าร้านค้า"
                        ></v-checkbox>
                      </v-col>
                      <v-col xs="12" sm="12" md="6" lg="4" xl="4" cols="12">
                        <v-checkbox
                          class="ma-0"
                          color="#D6BFAF"
                          v-model="input_set.claim_account"
                          hide-details="auto"
                          label="สิทธิ์การเข้าระบบบัญชี"
                        ></v-checkbox>
                      </v-col>
                      <v-col xs="12" sm="12" md="6" lg="4" xl="4" cols="12">
                        <v-checkbox
                          class="ma-0"
                          color="#D6BFAF"
                          v-model="input_set.claim_promotion"
                          hide-details="auto"
                          label="สิทธิ์การเข้าถึงโปรโมชั่น"
                        ></v-checkbox>
                      </v-col>
                      <v-col xs="12" sm="12" md="6" lg="4" xl="4" cols="12">
                        <v-checkbox
                          class="ma-0"
                          color="#D6BFAF"
                          v-model="input_set.claim_product"
                          hide-details="auto"
                          label="สิทธิ์การเข้าจัดการข้อมูลสินค้า"
                        ></v-checkbox>
                      </v-col>
                      <v-col xs="12" sm="12" md="6" lg="4" xl="4" cols="12">
                        <v-checkbox
                          class="ma-0"
                          color="#D6BFAF"
                          v-model="input_set.claim_stock_report"
                          hide-details="auto"
                          label="สิทธิ์การเข้าดูรายงานคลัง"
                        ></v-checkbox>
                      </v-col>
                      <v-col xs="12" sm="12" md="6" lg="4" xl="4" cols="12">
                        <v-checkbox
                          class="ma-0"
                          color="#D6BFAF"
                          v-model="input_set.claim_employee"
                          hide-details="auto"
                          label="สิทธิ์การเข้าจัดการพนักงาน"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="title_page ma-3" style="justify-content: center">
                    <v-btn
                      type="submit"
                      class="btn_add_data"
                      elevation="4"
                      large
                      >บันทึก</v-btn
                    >
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import img_holder from "@/assets/arin_assets/image_sun_color.png";
import img_holder_document from "@/assets/arin_assets/image_sun_color.png";
import img_holder_cert from "@/assets/arin_assets/image_sun_color.png";
import { isTelephone, taxNumber, validateEmail, onPaste } from "@/js/handler";
import Swal from "sweetalert2";
import { HTTP_ARIN } from "@/axios_arin";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Edit_employee",
  data() {
    return {
      loading_page: false,
      img_holder: img_holder,
      img_holder_document: img_holder_document,
      img_holder_cert: img_holder_cert,
      picture: null,
      picture_preview: null,
      id_card: null,
      id_card_preview: null,
      pharmacycouncil: null,
      pharmacycouncil_preview: null,
      password: "",
      password_confirmation: "",
      input_set: {
        id: "",
        em_code: "",
        name: "",
        tel: "",
        bank: "",
        bank_number: "",
        claim_status: 0,
        claim_POS: 0,
        claim_barcode: 0,
        claim_cancelbill: 0,
        claim_report: 0,
        claim_store: 0,
        claim_account: 0,
        claim_promotion: 0,
        claim_product: 0,
        claim_stock_report: 0,
        claim_employee: 0,
      },
      banking_list: [],
      sub_menu: [
        {
          text: "ทีมงาน",
          disabled: false,
        },
        {
          text: "แก้ไขทีมงาน",
          disabled: false,
          href: "#",
        },
      ],
    };
  },
  methods: {
    checkFirstChar(value) {
      if (value.startsWith(" ")) {
        this.input_set.em_code = value.trimStart();
      }
    },
    checkFirstCharName(value) {
      if (value.startsWith(" ")) {
        this.input_set.name = value.trimStart();
      }
    },
    // ฟังค์ชั่น การแสดงรายละเอียด
    getShow_api() {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/employee/showedit/" + this.$route.params.id, config).then(
        (res) => {
          if (res.data.successful === true) {
            this.input_set = res.data.employeeDetailedit;
          }
        }
      );
    },
    // GET ข้อมูลธนาคาร
    getBankList() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/bank", config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.banking_list = res.data.bankList;
        }
      });
    },
    // ฟังค์ชั่น การกด input file
    getFile_picture() {
      let fileUpload = document.getElementById("fileUpload_picture");
      if (fileUpload != null) {
        fileUpload.click();
      }
    },
    getFile_id_card() {
      let fileUpload = document.getElementById("fileUpload_id_card");
      if (fileUpload != null) {
        fileUpload.click();
      }
    },
    getFile_pharmacycouncil() {
      let fileUpload = document.getElementById("fileUpload_pharmacycouncil");
      if (fileUpload != null) {
        fileUpload.click();
      }
    },
    // ฟังค์ชั่น การดักนามสกุลไฟล์ และ preview image
    onFileChange_picture(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload;
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split(".").pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: "อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)",
            icon: "error",
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.input_set.emp_picture = null;
          });
        } else {
          if (file) {
            this.input_set.emp_picture = URL.createObjectURL(file);
            URL.revokeObjectURL(file);
          } else {
            this.input_set.emp_picture = null;
          }
        }
      }
    },
    onFileChange_id_card(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload;
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split(".").pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: "อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)",
            icon: "error",
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.input_set.id_care = null;
          });
        } else {
          if (file) {
            this.input_set.id_care = URL.createObjectURL(file);
            URL.revokeObjectURL(file);
          } else {
            this.input_set.id_care = null;
          }
        }
      }
    },
    onFileChange_pharmacycouncil(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload;
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split(".").pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: "อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)",
            icon: "error",
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.input_set.pharmacycouncil = null;
          });
        } else {
          if (file) {
            this.input_set.pharmacycouncil = URL.createObjectURL(file);
            URL.revokeObjectURL(file);
          } else {
            this.input_set.pharmacycouncil = null;
          }
        }
      }
    },
    // ฟังค์ชั่น การนำไป update
    editEmployee() {
      let claim_status = 0;
      let claim_POS = 0;
      let claim_barcode = 0;
      let claim_cancelbill = 0;
      let claim_report = 0;
      let claim_store = 0;
      let claim_account = 0;
      let claim_promotion = 0;
      let claim_product = 0;
      let claim_stock_report = 0;
      let claim_employee = 0;

      if (this.input_set.claim_status === 1) {
        claim_status = 1;
      } else {
        claim_status = 0;
      }
      if (this.input_set.claim_POS === true || this.input_set.claim_POS === 1) {
        claim_POS = 1;
      } else {
        claim_POS = 0;
      }
      if (
        this.input_set.claim_barcode === true ||
        this.input_set.claim_barcode === 1
      ) {
        claim_barcode = 1;
      } else {
        claim_barcode = 0;
      }
      if (
        this.input_set.claim_cancelbill === true ||
        this.input_set.claim_cancelbill === 1
      ) {
        claim_cancelbill = 1;
      } else {
        claim_cancelbill = 0;
      }
      if (
        this.input_set.claim_report === true ||
        this.input_set.claim_report === 1
      ) {
        claim_report = 1;
      } else {
        claim_report = 0;
      }
      if (
        this.input_set.claim_store === true ||
        this.input_set.claim_store === 1
      ) {
        claim_store = 1;
      } else {
        claim_store = 0;
      }
      if (
        this.input_set.claim_account === true ||
        this.input_set.claim_account === 1
      ) {
        claim_account = 1;
      } else {
        claim_account = 0;
      }
      if (
        this.input_set.claim_promotion === true ||
        this.input_set.claim_promotion === 1
      ) {
        claim_promotion = 1;
      } else {
        claim_promotion = 0;
      }
      if (
        this.input_set.claim_product === true ||
        this.input_set.claim_product === 1
      ) {
        claim_product = 1;
      } else {
        claim_product = 0;
      }
      if (
        this.input_set.claim_stock_report === true ||
        this.input_set.claim_stock_report === 1
      ) {
        claim_stock_report = 1;
      } else {
        claim_stock_report = 0;
      }
      if (
        this.input_set.claim_employee === true ||
        this.input_set.claim_employee === 1
      ) {
        claim_employee = 1;
      } else {
        claim_employee = 0;
      }

      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let store_id = this.$store.state.store_arin.user_data.store_id;
      if (this.input_set.tel.length != 10) {
        Swal.fire({
          title: "แจ้งเตือน",
          text: "กรุณากรอกหมายเลขโทรศัพท์ให้ครบ 10 หลัก",
          icon: "warning",
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        });
      } else {
        if (this.$refs.form.validate()) {
          let formData = new FormData();
          // formData.append('id', this.$route.params.id)
          formData.append("store_id", store_id);
          formData.append("picture", this.picture);
          formData.append("em_code", this.input_set.em_code);
          formData.append("name", this.input_set.name);
          formData.append("tel", this.input_set.tel);
          formData.append("bank", this.input_set.bank);
          formData.append("bank_number", this.input_set.bank_number);
          formData.append("id_care", this.id_card);
          formData.append("pharmacycouncil", this.pharmacycouncil);
          // เพิ่มเงื่อนไขนี้เข้าไป
          if (this.password && this.password.length > 0) {
            formData.append("password", this.password);
          }
          // สถานะทั้งหมด
          formData.append("claim_status", claim_status);
          formData.append("claim_POS", claim_POS);
          formData.append("claim_barcode", claim_barcode);
          formData.append("claim_cancelbill", claim_cancelbill);
          formData.append("claim_report", claim_report);
          formData.append("claim_store", claim_store);
          formData.append("claim_account", claim_account);
          formData.append("claim_promotion", claim_promotion);
          formData.append("claim_product", claim_product);
          formData.append("claim_stock_report", claim_stock_report);
          formData.append("claim_employee", claim_employee);

          HTTP_ARIN.post(
            "/employee/edit/" + this.$route.params.id,
            formData,
            config
          ).then((res) => {
            if (res.data.successful === true) {
              let timerInterval;
              Swal.fire({
                title: "เสร็จสิ้น",
                text: "แก้ไขข้อมูลเรียบร้อยแล้ว",
                icon: "success",
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading();
                  timerInterval = setInterval(() => {});
                },
                willClose: () => {
                  clearInterval(timerInterval);
                  setTimeout(function () {
                    window.location.href = "/arin/adminlist";
                  });
                },
              });
            } else {
              Swal.fire({
                title: "ไม่สามารถดำเนินการได้!",
                html: "กรุณากรอกเบอร์โทรอีกครั้งเนื่องจากมีเบอร์นี้ในระบบแล้ว",
                icon: "error",
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              });
            }
          });
        }
      }
    },
    isNumber: function (evt, number) {
      return isTelephone(evt, number);
    },
    isTaxNumber: function (evt, number) {
      return taxNumber(evt, number);
    },
    isEmail: function (evt) {
      return validateEmail(evt);
    },
    isPaste: function (evt) {
      return onPaste(evt);
    },
  },
  mounted() {
    this.getShow_api();
    this.getBankList();
  },
};
</script>

<style scoped>
.title_page h4.breadcrumb_title_page {
  font-size: 20px !important;
}

.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px);
}

.theme--light.v-timeline:before {
  background-color: #d6bfaf;
  width: 4px;
}

/* .header-content {
  margin-left: -15px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
  margin-top: 2px;
  margin-bottom: 2px;
} */

.v-tab {
  font-size: 16px;
  font-weight: 500;
}

.v-tab.v-tab--active {
  font-size: 16px;
  font-weight: 700;
}

.content-font {
  color: #616a6b;
  font-weight: 500;
  font-size: 16px;
}

.title_form_main {
  background: #d6bfaf;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: 38px;
  left: calc(50% - 19px);
  width: 38px;
}

.title_form_header {
  background: #d6bfaf;
  padding: 4px 10px 4px 10px;
  /* opacity: 0.35; */
  border: 1px solid #d6bfaf;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  border-radius: 0px 30px 30px 0px;
}

.title_form_header_text {
  color: #616a6b;
}

.logo_timeline {
  padding: 6px;
}

.logo_timeline > img {
  max-width: 25px;
}

.text_title {
  color: #616a6b;
  font-weight: bold;
  font-size: 16px;
}

.grid_half {
  display: grid;
  grid-template-columns: 45% 55%;
}

.v-otp-input .v-input {
  padding: 10px !important;
}

.input-radius {
  border-radius: 10px;
}

.grid_radio {
  display: flex;
  justify-content: space-around;
}

.btn_width {
  width: 50%;
}

.image_half {
  display: grid;
  grid-template-columns: 40% 60%;
}

.input_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.mobile_btn {
  width: 15%;
}

.file_input_style {
  position: absolute;
  top: 55px;
  left: 150px;
  right: 0;
  bottom: 0;
}

.preview {
  border-radius: 10px;
}

.preview.profile_img {
  max-width: 300px;
  border-radius: 30px;
}

.btn_edit_logo {
  border-radius: 10px;
  background-color: #fff;
  position: absolute;
  top: 8px;
  right: 16px;
}

.logo_admin {
  width: 80px;
  height: 80px;
}

.logo_admin > img {
  max-width: 80px;
}

.btn_width {
  width: 50%;
}

.input-radius {
  border-radius: 10px;
}

.table-data-img-center {
  display: flex;
  justify-content: center;
}

.v-data-table__wrapper >>> span {
  font-size: 50px;
}

.title_form {
  display: flex;
  margin-top: 2px;
}

label.label_form_text {
  font-size: 16px !important;
  color: #616a6b !important;
}

.btn_add_data {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
    #88b358 !important;
  border-radius: 10px;
  width: 15%;
}

@media only screen and (min-width: 0px) AND (max-width: 361px) {
}

@media only screen and (max-width: 600px) {
  .title_page h4.breadcrumb_title_page,
  .v-tab {
    font-size: 14px !important;
  }

  .v-timeline-item__divider {
    display: none !important;
  }
}

@media only screen and (min-width: 601px) AND (max-width: 960px) {
}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {
}

@media only screen and (min-width: 1265px) AND (max-width: 1904px) {
}
</style>
